import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Spinner.module.scss'

interface ISpinnerProps {
  // A thumb or a logo takes a smaller ring than a product photo.
  small?: boolean
  // The box of the picture it stands in for, so nothing moves when the picture arrives.
  className?: string
}

// Amazon's loader: a grey ring with a clear quarter, centred in the place of the one picture it waits for.
const Spinner = ({ small = false, className = '' }: ISpinnerProps) => {
  const { t } = useSurveyLocale()

  return (
    <div
      className={`${style.box} ${className}`}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-Spinner"
    >
      <span className={`${style.ring} ${small ? style.small : ''}`} />
    </div>
  )
}

export default Spinner
